import { Product } from '@danone-global/ct/interfaces'

/**
 * Returns a list of category ids
 * If isUpsellCategory is set to false, do not return
 */

export const getCategoriesFromProducts = (products: Product[]): string[] => {
  const categoryIds = []

  products?.forEach((product) => {
    product.masterData.current.categories.forEach((category) => {
      const isUpsellCategory = category.custom?.customFieldsRaw?.find(
        (i) => i.name === 'isUpsellCategory',
      )?.value

      if (isUpsellCategory === true && !categoryIds.includes(category.id)) {
        categoryIds.push(category.id)
      }
    })
  })

  return categoryIds
}
